import React, { useContext } from "react";
import styles from "./ListaDetallePreguntaReemplazo.module.css";
import GeneralContext from "../../context/GeneralContext";
import DetallePreguntaReemplazo from "../DetallePreguntaReemplazo/DetallePreguntaReemplazo";
import * as GeneralActions from "../../store/actions/generalActions";

const ListaDetallePreguntaReemplazo = ({ listaSolicitudes, state, setState }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]

    const agregarDetalleReemplazo = (indice) => {
        generalDispatch(GeneralActions.updateDetalleReemplazoField('idSolicitud', null, indice))
    }

    return (
        <React.Fragment>
            {cotizacion !== null && cotizacion.listaDetalleReemplazo !== undefined && cotizacion.listaDetalleReemplazo !== null
                ? cotizacion.listaDetalleReemplazo.map((detalleReemplazo, indice) => (
                    <div key={'solicitud_' + detalleReemplazo.idSolicitud}>
                        <DetallePreguntaReemplazo
                            indice={indice}
                            detalleReemplazo={detalleReemplazo}
                            listaSolicitudes={listaSolicitudes}
                            state={state}
                            setState={setState}
                        />
                    </div>
                ))
                : <DetallePreguntaReemplazo
                    indice={0}
                    detalleReemplazo={null}
                    listaSolicitudes={listaSolicitudes}
                    state={state}
                    setState={setState}
                />
            }

            {(cotizacion.listaDetalleReemplazo && cotizacion.listaDetalleReemplazo.length) < listaSolicitudes.length && state.igualNroPol
                ? <div className={styles.contenedor_boton}>
                    <button className={styles.btninsertar}
                        onClick={(e) => agregarDetalleReemplazo(cotizacion.listaDetalleReemplazo.length)}
                        >
                            <span>+</span>Insertar
                    </button>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default ListaDetallePreguntaReemplazo;